"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localState = undefined;

var _util = require("../../util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var localState = exports.localState = function localState(state) {
  return state.entities2.soldierTypes;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZW50aXRpZXMyL3NvbGRpZXItdHlwZXMvcm9vdC5qcyJdLCJuYW1lcyI6WyJVdGlsIiwibG9jYWxTdGF0ZSIsInN0YXRlIiwiZW50aXRpZXMyIiwic29sZGllclR5cGVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQ0E7O0lBQVlBLEk7Ozs7QUFDTCxJQUFNQyxrQ0FBYSxTQUFiQSxVQUFhLENBQUNDLEtBQUQ7QUFBQSxTQUN4QkEsTUFBTUMsU0FBTixDQUFnQkMsWUFEUTtBQUFBLENBQW5CIiwiZmlsZSI6InJvb3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuaW1wb3J0ICogYXMgVXRpbCBmcm9tIFwiLi4vLi4vdXRpbFwiXG5leHBvcnQgY29uc3QgbG9jYWxTdGF0ZSA9IChzdGF0ZTogVXRpbC5Sb290U3RhdGUpID0+XG4gIHN0YXRlLmVudGl0aWVzMi5zb2xkaWVyVHlwZXNcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/soldier-types/root.js
// module id = 805
// module chunks = 0